import * as React from 'react';
import { IListItemProps, ListItem } from '../List/ListItem';

export class MenuItem extends React.PureComponent<IListItemProps, {}> {
  public render() {
    return (
      <ListItem {...this.props} role="menuitem" style={{ fontSize: '1rem' }}>
        {this.props.children}
      </ListItem>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/Menu/MenuItem.tsx